/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 25/09/2023
*/

import { Typography, Container, CssBaseline, Grid, Box } from "@mui/material";

import ServicesCards from "./services-cards/ServicesCards";

import "./ServicesSection.css";
import { useScrollReveal } from "../../../helpers/ScrollReveal";
import { textlanguages } from "../../../data/textOfThePage";
import { useLanguageContext } from "../../../context/languageContext";
import ServicesCardsForPage from "./services-cards/ServicesCardsForPage";

export default function ServicesSection({ showCarrusel }) {
  const { languageSelected } = useLanguageContext();
  useScrollReveal([
    {
      selector: ".revealRightOurServices",
      options: {
        distance: "300px",
        duration: 1000,
        easing: "ease-out",
        origin: "right",
        reset: false,
        interval: 500,
      },
    },
    {
      selector: ".revealLeftOurServices",
      options: {
        distance: "300px",
        duration: 1000,
        easing: "ease-out",
        origin: "left",
        reset: false,
        interval: 500,
      },
    },
  ]);
  return (
    <Container
      disableGutters
      maxWidth={false}
      className="container-section"
      sx={{ bgcolor: "#fff" }}
    >
      <CssBaseline />
      <Grid
        container
        className="section-content"
        sx={{ display: "flex", justifyContent: "center", width: "100%" }}
      >
        <Grid item xs={1} lg={1} xl={showCarrusel ? 2 : 1}></Grid>
        <Grid
          item
          xs={10}
          lg={10}
          xl={showCarrusel ? 8 : 10}
          sx={
            showCarrusel
              ? {}
              : {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }
          }
        >
          <Typography
            variant="h3"
            className="section-header revealLeftOurServices"
          >
            {textlanguages[languageSelected].ourServices.title}
          </Typography>
          <Typography
            variant="h5"
            className="section-description revealRightOurServices"
            sx={{
              maxWidth: "920px",
              mx: "auto",
            }}
          >
            {textlanguages[languageSelected].ourServices.description}
          </Typography>
          <Box className="revealLeftOurServices">
            {showCarrusel ? <ServicesCards /> : <ServicesCardsForPage />}
          </Box>
        </Grid>
        <Grid item xs={1} lg={1} xl={showCarrusel ? 2 : 1}></Grid>
      </Grid>
    </Container>
  );
}
